<app-jumbotron title="IFA.tv Roku&#8482; Channel" justify="left" color="graph">
  <div class="container">
  <h2 class="mb-4">The Investment Education Destination</h2>
  <p class="col-lg-10 font-open mb-3 fs-6">IFA.tv is an investment education destination that provides webcasts explaining the investing strategies of 
    IFA.com and Mark Hebner's book, Index Funds: The 12-Step Recovery Program for Active Investors, with Foreword by Nobel Laureate 
    Harry Markowitz. Hebner's mission is to change the way the world invests by replacing speculation with education.</p><br>
  </div>

</app-jumbotron>

<div class="container">
  <div class="col-md-12">
    <div class="row mt-5">
      <div class="col-md-4 col-sm-12 col-xs-12 text-center mt-5">
          <a href="https://owner.roku.com/add/ifa" target="_blank" class="roku-img">
              <img src="https://services.ifa.com/art/images/2100_2022-5-24-10-1-51.png" border="0" class="roku-img"/></a>
          <a href="https://owner.roku.com/add/ifa" target="_blank">
              <img src="https://services.ifa.com/art/images/2101_2022-5-24-10-2-10.jpg" border="0" width="300" class="roku-img roku-phones"/></a>
      </div>
      <div class="col-md-4 col-sm-12 col-xs-12 text-center mt-5">

        <a href="https://owner.roku.com/add/ifa" target="_blank" class="roku-img">
            <img src="https://services.ifa.com/art/images/2099_2022-5-24-10-1-27.png" width="150" class="center-block roku-img ifa-tv"></a>
    </div>
    <div class="col-md-4 col-sm-12 col-xs-12 text-center mt-4">
        <a href="https://owner.roku.com/add/ifa" target="_blank" class="roku-img">
            <img src="https://services.ifa.com/art/images/2102_2022-5-24-10-2-54.png" border="0" width="300" class="pull-right roku-img"/></a>
    </div>
  </div>
  <div class="row ">
    <div class="text-center mt-4 pb-5 mb-5">
    <a href="https://owner.roku.com/add/ifa" target="_blank" class=" center-block text-center green-button font-18 roku-add-channel" style="width:300px" >Add Channel</a>
    </div>
  </div>
</div>